<template>
  <main class="ref-auth login-target">
    <img class="login-target__background" src="https://www.midnightdesires.vip/img/login/login-bg.png" alt="">
    <div class="login-target__shade" aria-hidden="true"></div>
    <PageHeader back :service="false"><template #right><router-link to="/Language" class="ref-icon-button" :aria-label="$t('setting.language')"><img class="login-target__language" src="https://www.midnightdesires.vip/img/login/nav10.png" alt=""></router-link></template></PageHeader>
    <img class="login-target__logo" src="https://www.midnightdesires.vip/img/login/login-logo-v9.jpg" :alt="$t('frontend.common.brand_logo')">
    <form class="ref-auth__form" @submit.prevent="doLogin">
      <label class="ref-auth__field"><input v-model.trim="username" autocomplete="username" :placeholder="$t('auth.username_place')" :aria-label="$t('frontend.auth.username')"></label>
      <label class="ref-auth__field"><input v-model="password" :type="passwordType" autocomplete="current-password" :placeholder="$t('auth.pwd_place')" :aria-label="$t('frontend.auth.password')"><button type="button" :aria-label="$t(passwordType === 'password' ? 'frontend.auth.show_password' : 'frontend.auth.hide_password')" @click="switchPasswordType"><van-icon :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'" /></button></label>
      <p class="ref-auth__error" role="alert">{{ error }}</p>
      <span class="login-target__forgot">{{ $t("auth.forgetpwd") }}?</span>
      <router-link class="login-target__register" to="/Register">{{ $t("auth.no_account") }}</router-link>
      <button class="ref-primary" type="submit" :disabled="submitting">{{ submitting ? $t('frontend.auth.logging_in') : $t("auth.login") }}</button>
    </form>
  </main>
</template>
<script>
import PageHeader from "../../common/PageHeader";
export default {
  components: { PageHeader },
  data: () => ({ username: "", password: "", passwordType: "password", submitting: false, error: "" }),
  methods: {
    switchPasswordType() { this.passwordType = this.passwordType === "password" ? "text" : "password"; },
    async doLogin() {
      if (this.submitting) return;
      if (!this.username || !this.password) { this.error = this.$t('frontend.auth.credentials_required'); return; }
      this.submitting = true; this.error = "";
      try {
        const res = await this.$http({ method: "get", url: "member_login", data: { username: this.username, password: this.password } });
        if (Number(res.code) === 200 && res.data && res.data.id) { localStorage.setItem("token", res.data.id); this.$router.push("/Mine"); }
        else this.error = res.msg || this.$t('frontend.auth.login_failed');
      } catch (error) { this.error = this.$t('common.network_error'); }
      finally { this.submitting = false; }
    }
  },
  created() { if (localStorage.getItem("token")) this.$router.replace("/Mine"); }
};
</script>
<style>
.login-target {
  position: relative;
  min-height: 100vh;
  height: 100vh;
  padding: 0;
  overflow-y: scroll;
  background: linear-gradient(-45deg, #5e347f, #c2a8dc) !important;
}

.login-target__background { position: absolute; inset: 0; z-index: 0; width: 100%; height: 100%; object-fit: cover; }
.login-target__shade { position: absolute; inset: 0; z-index: 0; background: linear-gradient(180deg, rgba(255, 255, 255, 0), #5e347f); }
.login-target > :not(.login-target__background):not(.login-target__shade) { position: relative; z-index: 1; }

.login-target .ref-header { height: 13.25vw; padding: 0; background: transparent; }
.login-target .ref-header__side { min-width: 2.75rem; }
.login-target .ref-header__side .ref-icon-button { width: 2.75rem; }
.login-target .ref-icon-button { min-height: 13.25vw; }

.login-target__language { width: 2.6875rem; height: 2.6875rem; object-fit: contain; }
.login-target__logo { display: block; width: 27.25vw; height: 27.25vw; margin: 0 auto; object-fit: cover; }
.login-target .ref-auth__form { max-width: none; padding: 13.25vw 8vw 0; }
.login-target .ref-auth__field { width: 80.25vw; height: 13.5vw; margin: 0 0 5.25vw; padding: 0 2.75vw; border-radius: 999px; background: #fff; }
.login-target .ref-auth__field { transform: translateY(3px); }
.login-target .ref-auth__field:last-of-type { margin-bottom: 0; }
.login-target .ref-auth__field input { width: 100%; min-height: 10.75vw; padding: 0 2.35rem; color: #323233; background: transparent; font-size: 0.75rem; }
.login-target .ref-auth__field > .van-icon { left: 1.1rem; font-size: 1rem; }
.login-target .ref-auth__field button { right: 0.45rem; }
.login-target .ref-auth__error { min-height: 0; margin: 0; }
.login-target .ref-auth__error:empty { display: none; }
.login-target__forgot { display: block; margin: 2.75vw 0 0; color: #fff; font-size: 0.625rem; line-height: 2vw; text-align: right; transform: translateY(8px); }
.login-target__register { display: block; margin: 3.25vw 0 0; color: #fff; font-size: 0.6875rem; line-height: 2.75vw; text-align: center; transform: translateY(11px); }
.login-target .ref-primary { width: 80.25vw; min-height: 13.25vw; margin-top: 14.25vw; border-radius: 6.667vw; background: #6838a0; font-size: 0.875rem; transform: translateY(4px); }
</style>
